import { useState, useEffect } from "react";
import OpeningHoursStore from "components/stores/opening-hours-store";
import { createDate, DateHelper } from "@parksandresorts/core";

const useOpeningHours = () => {
  const [openingTime, setOpeningTime] = useState();
  useEffect(() => {
    OpeningHoursStore.getAllDates().then((response) => {
      setOpeningTime(response);
    });
  }, []);

  return openingTime;
};

const findOpeningHoursForDate = (response, selectedDate) => {
  return response?.find((item) =>
    item.areaOpeningHours.find(
      (area) => area.areaId === 1 && DateHelper.isEqualYYYYMMDD(area.dateFrom, selectedDate.toISOString())
    )
  );
};

const useIsParkOpenNow = () => {
  const now = createDate();
  const allOpeningHours = useOpeningHours();
  const todaysOpeningHours = findOpeningHoursForDate(allOpeningHours, now);
  if (!todaysOpeningHours) return false;

  const opens = createDate(todaysOpeningHours?.opens);
  const closing = createDate(todaysOpeningHours?.closing);
  return DateHelper.isDateInDateSpan(now, opens, closing);
};

const IsParkOpenNow = ({ onUpdate }) => {
  const boolean = useIsParkOpenNow();
  useEffect(() => {
    onUpdate(boolean);
  }, [boolean, onUpdate]);
  return null;
};

export { IsParkOpenNow, useIsParkOpenNow };
